/* eslint-disable react/jsx-no-literals */
import React from 'react'

function TwitterMaintenaceIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="75"
      height="75"
      viewBox="0 0 75 75"
      {...props}
    >
      <defs>
        <clipPath id="clip-path">
          <rect
            id="Rectangle_37"
            data-name="Rectangle 37"
            width="75"
            height="75"
            transform="translate(0.375)"
            fill="none"
          />
        </clipPath>
      </defs>
      <g id="Twitter" transform="translate(-0.375)">
        <g id="Group_14" data-name="Group 14" clipPath="url(#clip-path)">
          <path
            id="Path_27"
            data-name="Path 27"
            d="M75.385,37.693A37.693,37.693,0,1,1,37.693,0,37.693,37.693,0,0,1,75.385,37.693"
            transform="translate(0 -0.001)"
            fill="#5a99ec"
            fillRule="evenodd"
          />
          <path
            id="Path_28"
            data-name="Path 28"
            d="M82.994,130.346c18.41,0,28.477-15.252,28.477-28.477q0-.65-.029-1.294a20.357,20.357,0,0,0,4.993-5.182,19.975,19.975,0,0,1-5.748,1.576,10.044,10.044,0,0,0,4.4-5.536,20.057,20.057,0,0,1-6.355,2.429,10.018,10.018,0,0,0-17.056,9.128,28.415,28.415,0,0,1-20.63-10.457,10.016,10.016,0,0,0,3.1,13.361,9.935,9.935,0,0,1-4.533-1.252c0,.042,0,.084,0,.128a10.013,10.013,0,0,0,8.03,9.812,9.993,9.993,0,0,1-4.52.171,10.02,10.02,0,0,0,9.35,6.952,20.083,20.083,0,0,1-12.431,4.284,20.34,20.34,0,0,1-2.387-.139,28.335,28.335,0,0,0,15.342,4.5"
            transform="translate(-52.918 -70.945)"
            fill="#fff"
          />
        </g>
      </g>
    </svg>
  )
}

export default TwitterMaintenaceIcon
